import update from 'immutability-helper';
import { ExtendedStarsWidgetSettings } from 'types/settings';
import { initialWidgetRequest, WidgetRequest } from 'types/widget';
import { useReviews } from 'utilities/api';

import { useSettings } from 'components/SettingsProvider';
import { SkeletonAction } from 'components/SkeletonAction';
import { Stars } from 'components/Stars';
import { Text } from 'components/Text';

export function StarsWidget() {
  const {
    utils: { product },
    display_near_stars,
  } = useSettings<ExtendedStarsWidgetSettings>();
  const request: WidgetRequest = update(initialWidgetRequest, {
    filters: {
      product_ids: { $set: product ? [product.id] : [] },
    },
  });
  const { reviews, isLoading } = useReviews(request);

  if (isLoading) {
    return <SkeletonAction />;
  }

  const rating = reviews[0]?.product_overall_rating ?? 0;
  const reviewsCount = reviews[0]?.product_reviews_count ?? 0;

  const connectedMarkup = (function () {
    switch (display_near_stars) {
      case 'COUNT':
        return <Text as="span">{`(${reviewsCount})`}</Text>;
      case 'RATING':
        return <Text as="span">{`(${rating})`}</Text>;
      default:
        return null;
    }
  })();

  return (
    <Stars
      url="#wbtx-reviews"
      value={rating}
      connectedRight={connectedMarkup}
    />
  );
}
